import React from 'react';
import './Header.css';

function Header() {
  return (
    <header>
      <nav className="header header--black">
        <a className="header--black__logo" href="https://www.cnn.com/">
          <img
            src="https://i.cdn.turner.com/cnn/.element/img/4.0/logos/cnn_logo_badge.png"
            alt="CNN logo"
            className="header--black__logo--img"
          />
        </a>
        <a className="header--black__text" href="https://www.cnn.com/">
          {'< Back to CNN'}{' '}
        </a>
      </nav>
      <div className="header header--gold">
        <p className="header--gold__text">Content by Mastercard</p>
      </div>
    </header>
  );
}

export default Header;
